import styled from 'styled-components';

const Weather = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 2rem 0;

  h1 {
    width: 100%;
    font-family: 'Concert One';
    color: white;
    font-size: 3rem;
    padding: 0 1rem;

    @media only screen and (max-width: 400px) {
      font-size: 2rem;
    }
  }

  .weather-overview {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: white;

    h3 {
      font-size: 3.5rem;
      font-family: 'Concert One';

      @media only screen and (max-width: 350px) {
        font-size: 2rem;
      }
    }

    img {
      width: 150px;
      height: 150px;

      @media only screen and (max-width: 350px) {
        width: 100px;
        height: 100px;
      }
    }
  }

  .weather-detail {
    background-color: rgba(255, 255, 255, 0.2);
    width: 50%;
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    color: white;

    @media only screen and (max-width: 700px) {
      width: 70%;
    }

    @media only screen and (max-width: 600px) {
      width: 80%;
    }

    @media only screen and (max-width: 500px) {
      width: 90%;
    }

    .detail {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      margin: 1rem;
      font-family: 'Economica', sans-serif;

      h4 {
        font-size: 1.3rem;
      }

      p {
        font-size: 1.1rem;
      }
    }
  }
`;

export default Weather;
